import { useState, useEffect } from 'react'
import { logEvent } from './eventLog.js'
import { supabase } from '../lib/supabase.js'

const LS_KEY="estoqueos_notifications";
const MAX_NOTIF=500;

function loadNotif(){
  try{const raw=localStorage.getItem(LS_KEY);if(raw){const parsed=JSON.parse(raw);if(Array.isArray(parsed))return parsed;}}catch(e){}
  return[];
}
function saveNotif(list){
  try{localStorage.setItem(LS_KEY,JSON.stringify(list.slice(0,MAX_NOTIF)));}catch(e){}
}

async function sbLoadNotif(){
  const{data,error}=await supabase.from('notificacoes').select('id,tipo,titulo,mensagem,entidade,id_entidade,usuario,lida,para,created_at').order('created_at',{ascending:false}).limit(MAX_NOTIF);
  if(error||!data||data.length===0)return null;
  return data.map(r=>({
    id:r.id,
    tipo:r.tipo,
    titulo:r.titulo,
    mensagem:r.mensagem,
    entidade:r.entidade,
    id_entidade:r.id_entidade,
    usuario:r.usuario,
    lida:r.lida,
    para:r.para,
    timestamp:r.created_at,
  }));
}
async function sbUpsertNotif(notif){
  const{error}=await supabase.from('notificacoes').upsert({
    id:String(notif.id),
    tipo:notif.tipo??null,
    titulo:notif.titulo??null,
    mensagem:notif.mensagem??null,
    entidade:notif.entidade??null,
    id_entidade:notif.id_entidade??null,
    usuario:notif.usuario??null,
    lida:notif.lida??false,
    para:notif.para??null,
    created_at:notif.timestamp??new Date().toISOString(),
  },{onConflict:'id'});
  if(error)console.warn('supabase notificacoes upsert error',error);
}
async function sbDeleteNotif(id){
  const{error}=await supabase.from('notificacoes').delete().eq('id',String(id));
  if(error)console.warn('supabase notificacoes delete error',error);
}

let _notif=loadNotif();
let _listeners=[];
let _nReady=false;

function subNotif(fn){_listeners.push(fn);return()=>{_listeners=_listeners.filter(f=>f!==fn);};}
function setGlobalNotif(fn){
  _notif=fn(_notif);
  saveNotif(_notif);
  _listeners.forEach(f=>f(_notif));
}

async function initNotif(){
  if(_nReady)return;
  _nReady=true;
  const remote=await sbLoadNotif();
  if(remote){
    _notif=remote;
    saveNotif(_notif);
    _listeners.forEach(f=>f(_notif));
  }
  return _notif;
}

export function useGlobalNotifications(){
  const[n,sN]=useState(()=>_notif);
  useEffect(()=>{
    sN(_notif);
    const unsub=subNotif(sN);
    initNotif().then(()=>sN([..._notif]));
    return unsub;
  },[]);
  return[n,setGlobalNotif];
}

export function addNotification({tipo,titulo,mensagem,entidade,id_entidade,usuario="Sistema",para=null}){
  const notif={
    id:crypto.randomUUID(),
    tipo,titulo,mensagem,entidade,
    id_entidade:String(id_entidade||""),
    usuario,para,
    timestamp:new Date().toISOString(),
    lida:false,
  };
  setGlobalNotif(prev=>[notif,...prev]);
  sbUpsertNotif(notif);
  logEvent({
    tipo_evento:"NOTIFICACAO_"+tipo,
    usuario,
    entidade:entidade||"SISTEMA",
    id_entidade:String(id_entidade||""),
    detalhes:`${titulo} — ${mensagem}`,
  });
}

export function markAsRead(id){
  setGlobalNotif(prev=>prev.map(n=>n.id===id?{...n,lida:true}:n));
  sbUpsertNotif({id,lida:true});
}

export function markAllAsRead(){
  setGlobalNotif(prev=>prev.map(n=>({...n,lida:true})));
  _notif.forEach(n=>sbUpsertNotif({...n,lida:true}));
}

export function deleteNotification(id){
  setGlobalNotif(prev=>prev.filter(n=>n.id!==id));
  sbDeleteNotif(id);
}